var React = require('react');

function IconTitleBarBackChevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.7071 1.70711C7.09763 1.31659 7.09763 0.683424 6.70711 0.292898C6.31659 -0.0976291 5.68342 -0.097633 5.2929 0.292889L6.7071 1.70711ZM1 5.99994L0.292898 5.29283C0.105359 5.48036 0 5.73472 0 5.99994C0 6.26516 0.105359 6.51951 0.292898 6.70705L1 5.99994ZM5.2929 11.707C5.68342 12.0975 6.31659 12.0975 6.70711 11.707C7.09763 11.3165 7.09763 10.6833 6.7071 10.2928L5.2929 11.707ZM5.2929 0.292889L0.292898 5.29283L1.7071 6.70705L6.7071 1.70711L5.2929 0.292889ZM0.292898 6.70705L5.2929 11.707L6.7071 10.2928L1.7071 5.29283L0.292898 6.70705Z","fill":"#404C63"}));
}

IconTitleBarBackChevron.defaultProps = {"width":"7","height":"12","viewBox":"0 0 7 12","fill":"none"};

module.exports = IconTitleBarBackChevron;

IconTitleBarBackChevron.default = IconTitleBarBackChevron;
